'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');
require('../../enums/accordion.js');
require('../../enums/alert.js');
require('../../enums/avatar.js');
require('../../enums/breakpoints.js');
require('../../enums/button.js');
require('../../enums/code-editor.js');
require('../../enums/colors.js');
require('../../enums/combobox.js');
require('../../enums/date.js');
require('../../enums/drag-and-drop.js');
require('../../enums/dialog.js');
require('../../enums/divider.js');
require('../../enums/dropdown.js');
require('../../enums/fieldset.js');
require('../../enums/font-icon.js');
require('../../enums/fonts.js');
var headings = require('../../enums/headings.js');
require('../../enums/input.js');
require('../../enums/keys.js');
require('../../enums/list.js');
require('../../enums/listbox.js');
require('../../enums/loader.js');
require('../../enums/margin.js');
require('../../enums/option.js');
require('../../enums/pill.js');
require('../../enums/placements.js');
require('../../enums/popout.js');
require('../../enums/privacy.js');
require('../../enums/radio-group.js');
require('../../enums/status.js');
require('../../enums/switch.js');
require('../../enums/table.js');
require('../../enums/tooltip.js');
require('../../enums/transitions.js');
require('../../enums/widths.js');
require('../../themes/alert.js');
require('../../themes/button.js');
require('../../themes/checkbox.js');
require('../../themes/divider.js');
require('../../themes/dropdown.js');
require('../../themes/fieldset.js');
var fonts = require('../../themes/fonts.js');
require('../../themes/input.js');
require('../../themes/list.js');
require('../../themes/listbox.js');
require('../../themes/loader.js');
require('../../themes/option.js');
require('../../themes/popout.js');
require('../../themes/switch.js');
require('../../themes/themes.js');
require('../../themes/tooltip.js');

const getHeadingLevel = (options)=>{
    const { level  } = options;
    switch(level){
        case headings.HeadingLevels.h1:
            {
                return styled.css`
        font-family: ${fonts.fontFamilyBold};
        font-size: ${fonts.fontSizeXxLarge}px;
        font-weight: ${fonts.fontWeightBold};
        line-height: 50px;
      `;
            }
        case headings.HeadingLevels.h2:
            {
                return styled.css`
        font-family: ${fonts.fontFamilyMedium};
        font-size: ${fonts.fontSizeXLarge}px;
        font-weight: ${fonts.fontWeightMedium};
        line-height: 40px;
      `;
            }
        case headings.HeadingLevels.h3:
            {
                return styled.css`
        font-family: ${fonts.fontFamilyBook};
        font-size: ${fonts.fontSizeLarge}px;
        font-weight: ${fonts.fontWeightBook};
        line-height: 28px;
      `;
            }
        case headings.HeadingLevels.h4:
            {
                return styled.css`
        font-family: ${fonts.fontFamilyBook};
        font-size: ${fonts.fontSizeMedium}px;
        font-weight: ${fonts.fontWeightBook};
        line-height: 24px;
      `;
            }
        case headings.HeadingLevels.h5:
            {
                return styled.css`
        font-family: ${fonts.fontFamilyBook};
        font-size: ${fonts.fontSizeSmall}px;
        font-weight: ${fonts.fontWeightBook};
        line-height: 22px;
      `;
            }
        // HeadingLevels.h6
        default:
            {
                return styled.css`
        font-family: ${fonts.fontFamilyBook};
        font-size: ${fonts.fontSizeXxSmall}px;
        font-weight: ${fonts.fontWeightBook};
        line-height: 18px;
      `;
            }
    }
};

exports.getHeadingLevel = getHeadingLevel;
//# sourceMappingURL=heading.js.map
